import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PagePathResolver implements Resolve<string> {
  resolve(route: ActivatedRouteSnapshot): Observable<string> {
    const path = this.getFullPathFromRoute(route);

    return of(path);
  }

  private getFullPathFromRoute(route: ActivatedRouteSnapshot): string {
    let segments: string[] = [];

    for (const r of route.pathFromRoot) {
      segments = [...segments, ...r.url.map((s) => s.path)];
    }

    const url = segments.filter((s) => !!s).join('/');

    return `/${url}`;
  }
}
